/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isBrowser } from 'react-device-detect';
import PropTypes from 'prop-types';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { SendCryptoScreensFlow } from '../../constants';
import ChecklistOption from '../../../../components/Checklist';
import CurrencyIcon from '../../../../components/CurrencyIcon';
import SearchInput from '../../../../components/SearchInput';
import { currencies } from '../../../../utilities/constants';

const WhitelistChangeLedgerWallet = ({
  openScreen,
  onChangeWallet,
  wallets,
  isSendCryptoModal,
}) => {
  const { t: translate } = useTranslation();
  const [searchText, setSearchText] = useState('');

  const onSearchChange = (e) => {
    setSearchText(e.target.value.toLowerCase());
  };

  const allowedOptions = useMemo(() => {
    const _accounts = wallets.filter((obj) => obj?.wallet_type === 'crypto' || obj?.is_stablecoin);
    return _accounts;
  }, [wallets]);

  const filteredOptions = useMemo(
    () => allowedOptions.filter((item) => item.coin.toLowerCase().includes(searchText)),
    [searchText, allowedOptions]
  );

  const renderTitle = () => (
    <div
      className={`w-100 ${
        isBrowser ? 'd-flex align-items-center justify-content-between mb-5' : ''
      } `}>
      <div>
        <b className="text-f5 text-dark ms-2">{translate('whitelist_change_ledger_currency')}</b>
      </div>
    </div>
  );

  return (
    <ModalBodyLayout
      withBack
      onPrevClick={() => openScreen(SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES)}
      renderTitle={renderTitle}
      title={null}
      isScrollable>
      <div className="d-flex flex-fill flex-column justify-content-start align-content-center h-100">
        <SearchInput
          placeholder={translate('whitelist_search_ledger_currency')}
          className="mt-0 mb-4"
          onChange={onSearchChange}
          value={searchText}
        />
        <div className="wallet-list ">
          {filteredOptions &&
            filteredOptions.map((option) => (
              <ChecklistOption
                key={option.id}
                title={option.coin.toUpperCase()}
                subTitle={option.wallet_address}
                value={option}
                withCheckbox={false}
                onClick={() => {
                  onChangeWallet(option);
                  openScreen(
                    isSendCryptoModal
                      ? SendCryptoScreensFlow.SEND_CRYPTO
                      : SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES
                  );
                }}
                className="mb-2"
                isChecked
                withIcon={
                  <CurrencyIcon
                    currencyCode={option?.coin?.toLowerCase()}
                    className="me-2"
                    style={{
                      width: '1.5rem',
                      height: '1.5rem',
                      ...(option?.coin?.toUpperCase() === currencies.XRP.icon
                        ? {
                            backgroundColor: 'white',
                            padding: '1px',
                            borderRadius: '20px',
                          }
                        : {}),
                    }}
                  />
                }
                withArrow
              />
            ))}
        </div>
      </div>
    </ModalBodyLayout>
  );
};

export default WhitelistChangeLedgerWallet;

WhitelistChangeLedgerWallet.propTypes = {
  openScreen: PropTypes.func.isRequired,
  wallet: PropTypes.shape({
    coin: PropTypes.string.isRequired,
  }).isRequired,
  onChangeWallet: PropTypes.func.isRequired,
  wallets: PropTypes.any.isRequired,
  isSendCryptoModal: PropTypes.bool,
};

WhitelistChangeLedgerWallet.defaultProps = {
  isSendCryptoModal: true,
};
